import axios from 'axios';
import { auth } from '../firebase';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://oplixi-creator.vercel.app';

const viewer = axios.create({
  baseURL: BACKEND_URL,
  timeout: 10000,
});

// Attach Firebase ID token to every request
viewer.interceptors.request.use(async (config) => {
  try {
    const user = auth?.currentUser;
    if (user) {
      const token = await user.getIdToken();
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch {
    // Auth not available — continue without token
  }
  return config;
});

// My List
export const getMyList = () => viewer.get('/api/my-list');

export const addToMyList = (movie) =>
  viewer.post('/api/my-list', {
    movieId: movie.id,
    title: movie.title,
    thumbnailUrl: movie.thumbnailUrl || movie.poster_path,
    publishedAt: movie.publishedAt || movie.release_date,
    duration: movie.duration || movie.runtime,
  });

export const removeFromMyList = (movieId) =>
  viewer.delete(`/api/my-list/${movieId}`);

// Watch History
export const getWatchHistory = () => viewer.get('/api/watch-history');

export const getContinueWatching = () => viewer.get('/api/continue-watching');

export const saveWatchProgress = (movie, currentTime, duration) =>
  viewer.post('/api/watch-history', {
    movieId: movie.id,
    currentTime,
    duration,
  });

export const removeFromHistory = (movieId) =>
  viewer.delete(`/api/watch-history/${movieId}`);

// Account — permanently delete all server-side data for the signed-in user
// (My List, watch history, subscription records). The Firebase Auth user
// itself is deleted client-side in AuthContext after this resolves.
export const deleteAccountData = () => viewer.delete('/api/account');

export default viewer;
